import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { FaUmbrellaBeach, FaArrowRight, FaClock, FaUsers, FaCalendarAlt } from "react-icons/fa";
import disciplinas from './static/disciplinas';

import './App.css';

const Disciplina = ({ disciplina }) => {
  let ch = disciplina["CH Sem Síncrona"] + disciplina["CH Sem Assíncrona"];
  let color;

  if (ch <= 4) {
    color = "success";
  }
  else if (ch <= 6) {
    color = "warning";
  }
  else {
    color = "danger";
  };
  return (
    <Col className="mt-2">
      <Card className="card border-dark" /*style={{minHeight: '35rem'}}*/ >
        <Card.Header className="bg-light text-center">
          <h5><a href={`${process.env.PUBLIC_URL}/planos/${disciplina['Planos de Ensino']}`}>{disciplina["Código da disciplina"]}</a></h5>
          <p /*style={{ minHeight: '4rem' }} */ className="text-capitalize">{disciplina["Nome da disciplina"]}</p>
          <hr style={{ width: '50%' }} />
          <p className="text-capitalize"><small>{disciplina["Docente responsável"]}</small></p>

          <p>
            <small>
              Carga horária:<br></br>
            </small>
            <Badge style={{ width: '9rem' }} variant={color}>
              <FaClock /> {disciplina["CH Sem Síncrona"] + disciplina["CH Sem Assíncrona"]} horas/semana
            </Badge>
            <ProgressBar style={{ width: '9rem' }} className="mt-1 mx-auto">
              <ProgressBar variant="info" now={disciplina['CH Sem Síncrona'] * 100 / ch} key={1} label={`${disciplina['CH Sem Síncrona']}h sinc.`} />
              <ProgressBar variant="secondary" now={disciplina['CH Sem Assíncrona'] * 100 / ch} key={2} label={`${disciplina['CH Sem Assíncrona']}h assinc.`} />
            </ProgressBar>
          </p>
          <p>
            <small>
              Período de aulas:<br></br>
            </small>
            <Badge variant="light">
              <FaCalendarAlt /> {disciplina["Semanas"]} semanas
            </Badge>
            <Badge variant="primary">
              {`${disciplina["Data de início"]}`} <FaArrowRight /> {`${disciplina['Data de fim']}`}
            </Badge><br />
            {disciplina['Meses'] && disciplina['Meses'].split(",").map((m) => (
              <Badge variant="primary">
                {m}
              </Badge>
            ))}
          </p>
          <p>
            <small>
              Recesso:<br></br>
            </small>
            <Badge className="text-break" variant="secondary">
              <FaUmbrellaBeach />
              {
                disciplina["Período Recesso"].split(';').map((v) => (
                  <>
                    {` ${v}`}
                    <br />
                  </>
                ))}
            </Badge>
          </p>
        </Card.Header>
        <Card.Body>
          <p>
            <small>Turmas, vagas e
            horários das atividades síncronas:
                  </small>
          </p>
          {
            disciplina["turmas"].map((t) => {
              return (
                <>
                  <p>
                    <strong>
                      {t.turno}
                    </strong>
                    {' ( '}<FaUsers />{' '}
                    {t.vagas}{' vagas)'}
                    <p>
                      <ul>
                        {t.horarios.map((h) => (<li>{h}</li>))}
                      </ul>
                    </p>
                  </p>
                </>
              );
            })
          }
        </Card.Body>
      </Card>
    </Col>
  );
};

const Semestre = ({ bg, title, disciplinas }) => {
  let skip = 0;
  let cor = bg ? bg : "primary";
  return (
    <Col xs={12} className="p-1">
      <Card className="p-0">
        <Card.Header className={`bg-${cor} text-light`}>
          {title}
        </Card.Header>
        <Card.Body>
          <Container fluid>
            <Row className="row-cols-xs-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
              {
                disciplinas && disciplinas.map((d, i, disciplinas) => {
                  if (skip > 0) { skip -= 1; return (null); }
                  let disciplina = d;
                  disciplina["turmas"] = [{
                    turno: disciplina['Curso 47A tarde 48A noite'] === "47A" ? "Tarde" : "Noite",
                    horarios: [`${disciplina['Dias da semana (ativ. síncronas)']} - ${disciplina['Horário (ativ. síncronas)']}`],
                    vagas: disciplina["Número de vagas (veteranos/calouros)"],
                  }]
                  let nTurmas = 1;


                  let linha = d;

                  while (i + skip + 1 < disciplinas.length && linha['Código da disciplina'] === disciplinas[i + skip + 1]['Código da disciplina'] && linha['Docente responsável'] === disciplinas[i + skip + 1]['Docente responsável']) {
                    skip += 1;

                    if (linha['Curso 47A tarde 48A noite'] === disciplinas[i + skip]['Curso 47A tarde 48A noite']) {
                      disciplina["turmas"][nTurmas - 1]["horarios"].push(
                        `${disciplinas[i + skip]['Dias da semana (ativ. síncronas)']} - ${disciplinas[i + skip]['Horário (ativ. síncronas)']}`);
                    }
                    else {
                      nTurmas++;
                      disciplina["turmas"].push({
                        turno: disciplinas[i + skip]['Curso 47A tarde 48A noite'] === "47A" ? "Tarde" : "Noite",
                        horarios: [`${disciplinas[i + skip]['Dias da semana (ativ. síncronas)']} - ${disciplinas[i + skip]['Horário (ativ. síncronas)']}`],
                        vagas: disciplinas[i + skip]['Número de vagas (veteranos/calouros)'],
                      });
                    }
                    linha = disciplinas[i + skip];
                  }

                  return (
                    <Disciplina disciplina={disciplina} />
                  )
                })
              }
            </Row>
          </Container>
        </Card.Body>
      </Card>
    </Col>

  );
};

const App = () => {
  return (
    <Container className="p-3">
      <h1 className="header">Segundo Período Especial TADS <small className="text-muted">(Ensino Remoto Emergencial)</small></h1>
      <p>
        A <a href="http://www.soc.ufpr.br/portal/wp-content/uploads/2020/10/RESOLU%C3%87%C3%83O-N%C2%BA-65-2020-CEPE.pdf">
          Resolução 65/20-CEPE
        </a>
        {" "}regulamenta, em caráter excepcional, novo período especial para o desenvolvimento de atividades de
        ensino nos cursos de educação superior, profissional e tecnológica da UFPR, no contexto das medidas
        de enfrentamento da pandemia de COVID-19 no País.
      </p>
      <p>
        A partir dessa resolução, o TADS oferatará um total de 37 disciplinas em 70 turmas! Todas elas estão listadas abaixo
        organizadas por período.
      </p>
      <p>
        As matrículas serão realizadas através do <a href="https://www.siga.ufpr.br">SIGA</a> durante o período de {" "}
        <strong>26/10/2020 (8:00 h) e encerra dia 28/10/2020 (23:59 h).</strong>.
      </p>
      <p>
        Ao escolher suas disciplinas, considere o seguinte:
        <ul>
          <li><strong>Carga horária semanal</strong>: a carga horária semanal exigida pela disciplina. É o tempo que a disciplina exigirá de dedicação por semana. Pode ser dividida em Síncrona e Assícrona:</li>
          <ul>
            <li>Carga horária semanal <strong>síncrona</strong>: carga horária semanal de atividades realizadas em tempo real pelo professor ou pela professora por meio de alguma plataforma de comunicação (Microsoft Teams, UFPR Virtual, Jitsi, entre outras);</li>
            <li>Carga horária semanal <strong>assíncrona</strong>: carga horária semanal de atividades a serem realizadas pelos e pelas estudantes em um espaço de tempo dirente das atividades síncronas;</li>
          </ul>
          <li><strong>Período de aulas</strong>: embora o Período Especial tenha início em novembro/20 e término em março/21, as disciplinas podem ter datas de início e término variadas dentro deste período;</li>
          <li><strong>Quantidade de semanas</strong>: quantidade efetiva de semanas em que a disciplina terá atividades. Algumas disciplinas podem ser mais concentradas (menos semanas) ou mais espaçadas (mais semanas);</li>
          <li><strong>Recesso</strong>: todas as disciplinas deverão respeitar os períodos de recesso estipulados na resolução (<strong>21/12 a 16/01/21</strong> e <strong>15/02/21 a 20/02/21</strong>). Porém, cada disciplina poderá ter períodos de recesso adicionais.</li>
          <li><strong>Turno e quantidade de vagas</strong>: Valores indicados como <code>X(Y/Z)</code> indicam: <code>X</code> vagas no total, sendo <code>Y</code> exclusivas para veteranos e <code>Z</code> exclusivas para calouros.</li>
          <li><strong>Plano de Ensino</strong>: documento que apresenta detalhes da metodologia estipulada por cada professor e professora para sua disciplina. <strong>Pode ser acessado clicando no código da disciplina.</strong></li>
          <li><strong>Carga horária total de disciplinas</strong>: Para o TADS, você poderá se matricular em um número de disciplinas que não ultrapasse o total de <strong>390 horas</strong> nesse período especial.</li>
        </ul>
      </p>
      <p>
        O prazo para <strong>cancelamento de matrícula</strong> é até o lançamento de nota e frequência no SIGA ou até 27/03/21, feito diretamente por vocês no SIGA.
      </p>
      <p>Em caso de dúvidas, entre em contato com a secretaria e coordenação do curso: <a href="mailto:coordtads@ufpr.br">coordtads@ufpr.br</a></p>
      <h2>Disciplinas Ofertadas</h2>
      <Row>
        <Semestre title="Primeiro Período" disciplinas={disciplinas.filter((a) => a["Período"] === 1)} />
        <Semestre title="Segundo Período" disciplinas={disciplinas.filter((a) => a["Período"] === 2)} />
        <Semestre title="Terceiro Período" disciplinas={disciplinas.filter((a) => a["Período"] === 3)} />
        <Semestre title="Quarto Período" disciplinas={disciplinas.filter((a) => a["Período"] === 4)} />
        <Semestre title="Quinto Período" disciplinas={disciplinas.filter((a) => a["Período"] === 5)} />
        <Semestre title="Sexto Período" disciplinas={disciplinas.filter((a) => a["Período"] === 6 || a['Período'] === "6+")} />
        <Semestre title="Optativas" disciplinas={disciplinas.filter((a) => a["Período"] === "Op")} />
      </Row>
    </Container>
  );
};

export default App;

